var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { LocalizationProvider } from "../locale";
import { ModifierItemInstanceAvailabilityService, ModifierItemInstancePriceService, } from "../ordering";
import { PModifierItemInstanceCreator } from "./PModifierItemInstanceCreator";
let PModifierItemInstanceCreatorFactory = class PModifierItemInstanceCreatorFactory {
    constructor(localizationProvider, modifierItemInstancePriceService, modifierItemInstanceAvailabilityService) {
        this.localizationProvider = localizationProvider;
        this.modifierItemInstancePriceService = modifierItemInstancePriceService;
        this.modifierItemInstanceAvailabilityService = modifierItemInstanceAvailabilityService;
        makeImmutable(this);
    }
    create(params) {
        return new PModifierItemInstanceCreator({
            modifierItemType: params.modifierItemType,
            domain: params.domain,
            behaviour: params.behaviour,
            localizationProvider: this.localizationProvider,
            modifierItemInstancePriceService: this.modifierItemInstancePriceService,
            modifierItemInstanceAvailabilityService: this.modifierItemInstanceAvailabilityService,
        });
    }
};
PModifierItemInstanceCreatorFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _a : Object, typeof (_b = typeof ModifierItemInstancePriceService !== "undefined" && ModifierItemInstancePriceService) === "function" ? _b : Object, typeof (_c = typeof ModifierItemInstanceAvailabilityService !== "undefined" && ModifierItemInstanceAvailabilityService) === "function" ? _c : Object])
], PModifierItemInstanceCreatorFactory);
export { PModifierItemInstanceCreatorFactory };
